import { Validator } from 'vee-validate/dist/vee-validate.minimal'

export default {
  methods: {
    addCustomValidator (validationName, validationOptions) {
      if (this.$validator.rules[validationName] === undefined) {
        Validator.extend(validationName, validationOptions)
      }
    },
  },
}
